import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import {CusFormLabel} from '../validation/Form-Components';
import appDetailsData from '../data/applicantdetailsdata.json';
import helper from '../factory/Helper';
import myInfoApiCountries from '../data/myInfoApiCountryList.json';

const ResiAddress = (props) => {

    const{ applicantDetails } = props;

    return(
        <div>
            <Field component={CusFormLabel} 
                leftLabelId={'lblBlk'} leftLabelName={appDetailsData.label.blk} 
                id={'blk'} name={applicantDetails.myInfo.ResBlkNo !== null? applicantDetails.myInfo.ResBlkNo:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblStreet'} leftLabelName={appDetailsData.label.street} 
                id={'st'} name={applicantDetails.myInfo.ResStreet !==null? applicantDetails.myInfo.ResStreet:''}  />

            <Field component={CusFormLabel} 
                leftLabelId={'lblLvl'} leftLabelName={appDetailsData.label.level} 
                id={'lvl'} name={applicantDetails.myInfo.ResFlrNum !==null? applicantDetails.myInfo.ResFlrNum:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblUno'} leftLabelName={appDetailsData.label.unitNo} 
                id={'uno'} name={applicantDetails.myInfo.ResUnitNo !==null? applicantDetails.myInfo.ResUnitNo:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblbuilding'} leftLabelName={appDetailsData.label.building} 
                id={'bld'} name={applicantDetails.myInfo.ResBldName !==null? applicantDetails.myInfo.ResBldName:''}  />

            <Field component={CusFormLabel} 
                leftLabelId={'lblPostalCode'} leftLabelName={appDetailsData.label.postalCode} 
                id={'ptc'} name={applicantDetails.myInfo.ResPostalCode !==null? applicantDetails.myInfo.ResPostalCode:''}  />

            <Field component={CusFormLabel} 
                leftLabelId={'lblcountry'} leftLabelName={appDetailsData.label.country} 
                id={'ctry'} name={applicantDetails.myInfo.ResCountry !==null? helper.getLabelInArray(applicantDetails.myInfo.ResCountry,myInfoApiCountries):''}  />
        </div>
    )
}

export default ResiAddress;